export default "__VITE_ASSET__DGh54iTN__"